export default __webpack_public_path__ + "static/media/Amattera-Million.115e8b8e.ttf";